var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBadge1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.6696 16.0674H27.7006V2.50598H13.969V16.0674H1V30.4385H13.969V44H27.7006V30.4385H40.6696V16.0674Z",
    stroke: "#19223F",
    strokeWidth: 0.655825,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0001 13.5615H32.0311V0H18.2996V13.5615H5.33057V27.9326H18.2996V41.494H32.0311V27.9326H45.0001V13.5615Z",
    fill: "#19223F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0312 26H24.6172V19.3906C24.6172 19.2083 24.6198 18.9844 24.625 18.7188C24.6302 18.4479 24.638 18.1719 24.6484 17.8906C24.6589 17.6042 24.6693 17.3464 24.6797 17.1172C24.6224 17.1849 24.5052 17.3021 24.3281 17.4688C24.1562 17.6302 23.9948 17.776 23.8438 17.9062L22.5312 18.9609L21.3672 17.5078L25.0469 14.5781H27.0312V26Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge1);
export default __webpack_public_path__ + "static/media/Badge1.913094f1f928396312cd9d2ed18305af.svg";
export { ForwardRef as ReactComponent };